// eslint-disable-next-line no-restricted-imports
import { LegalTaxResidenceFragment } from 'api/generated/graphql';
import { parseCountryEntity } from 'api/helpers/parseCountryEntity';
import { LegalTaxResidencesEntity } from 'api/types/entity/legal/legalTaxResidencesEntity';

export const parseLegalClientTaxResidency = (
  taxResidence: LegalTaxResidenceFragment
): LegalTaxResidencesEntity => ({
  country: parseCountryEntity(taxResidence.country),
  taxId: taxResidence.taxId,
});
